<template>
  <v-container fluid class="hyp-table-container">
    <v-tabs v-model="tab" align-with-title>
      <v-tab v-for="item in items" :key="item.tab" v-show="isTabVisible(item)">
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-card flat>
          <v-card-text>
            <component v-bind:is="item.content"></component>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
const EMITTED_ACTIONS = {
  CLICK_MINIMIZE: "click-minimize",
};

import { hasAssetsMgmtAdminAccess } from "@/services/user/user.service";
import { LABELS } from "@/common/constants/labels";

export default {
  name: "AssetsContent",
  components: {
    AssetsList: () => import("@/components/assetManagement/AssetsList.vue"),
    AssetsSetup: () => import("@/components/assetManagement/AssetsSetup.vue"),
    AssetsUpload: () => import("@/components/assetManagement/AssetsUpload.vue"),
    AssetsExport: () => import("@/components/assetManagement/AssetsExport.vue"),
    AssetsAlertMgmt: () =>
      import("@/components/assetManagement/AssetsAlertMgmt.vue"),
  },
  props: {
    isMinimized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: null,
      items: [
        {
          tab: `View My ${LABELS.assets}`,
          content: "AssetsList",
          isAdminOnly: false,
        },
        {
          tab: `Setup My ${LABELS.assets} Profile`,
          content: "AssetsSetup",
          isAdminOnly: true,
        },
        {
          tab: `Upload ${LABELS.assets}`,
          content: "AssetsUpload",
          isAdminOnly: true,
        },
        {
          tab: `Export ${LABELS.assets}`,
          content: "AssetsExport",
          isAdminOnly: true,
        },
      ],
      hasAssetsMgmtAdminAccess: hasAssetsMgmtAdminAccess(),
    };
  },
  computed: {},
  methods: {
    handleClickMinimize() {
      this.$emit(EMITTED_ACTIONS.CLICK_MINIMIZE);
    },
    isTabVisible(item) {
      return (
        !item.isAdminOnly || (item.isAdminOnly && this.hasAssetsMgmtAdminAccess)
      );
    },
  },
};
</script>

<style>
.content-container img {
  max-width: 460px;
}
</style>

<style scoped>
.details-container {
  height: 93vh;
  overflow-y: auto;
}
</style>
